import { CallbackHolder } from "abweb/utils/callback/CallbackHolder";
/**
 * Multi-cast event structure with one strongly typed argument.
 * For a class to implement an event broadcaster.
 */
export class Callback1Arg extends CallbackHolder {
  callAll(x) {
    // create a copy to iterate over, since listeners can unsubscribe themselves.
    for (let listener of this.getCallbacks()) {
      listener(x);
    }
  }
}
//# sourceMappingURL=Callback1Arg.js.map
